import { render, staticRenderFns } from "./ProposalCard.vue?vue&type=template&id=659ac846&scoped=true&"
import script from "./ProposalCard.vue?vue&type=script&lang=js&"
export * from "./ProposalCard.vue?vue&type=script&lang=js&"
import style0 from "./ProposalCard.vue?vue&type=style&index=0&id=659ac846&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659ac846",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/webapp-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
installComponents(component, {VBadge,VCard,VCardText,VCardTitle,VFlex,VIcon,VImg,VLayout,VSelect})
